export type IEnvironment = {
  SP_API_URL: string;
  AWS_CONNECTOR_ID: string;
  AWS_CF_TEMPLATE_URL: string;
  DASHBOARD_URL: string;
  DASHBOARD_ID: string;
  FIREBASE_API_KEY: string;
  DATADOG_APPLICATION_ID: string;
  DATADOG_CLIENT_TOKEN: string;
  DATADOG_SERVICE: string;
  DATADOG_SITE: string;
  INTERCOM_APP_ID: string;
  INTERCOM_API_BASE: string;
  APP_VERSION: string;
  MODE: string;

  // Metabase
  METABASE_ENABLED: boolean;
  METABASE_INSTANCE_URL: string;
  METABASE_INSIGHTS_ENTITY_ID: string;
  METABASE_PS_ENTITY_ID: string;
  METABASE_USER_GROUP_LG_ENTITY_ID: string;
  METABASE_USER_GROUP_SMALL_ENTITY_ID: string;
};

const getBool = (val: unknown): boolean => {
  return ['1', 'true'].includes(String(val || '').toLowerCase());
};

const meta = import.meta.env;

const Environment: IEnvironment = Object.freeze({
  SP_API_URL: (meta.VITE_SP_API_URL as string) || '',
  AWS_CONNECTOR_ID: (meta.VITE_AWS_CONNECTOR_ID as string) || '',
  AWS_CF_TEMPLATE_URL: (meta.VITE_AWS_CF_TEMPLATE_URL as string) || '',
  DASHBOARD_URL: (meta.VITE_DASHBOARD_URL as string) || '',
  DASHBOARD_ID: (meta.VITE_DASHBOARD_ID as string) || '',
  FIREBASE_API_KEY: (meta.VITE_FIREBASE_API_KEY as string) || '',
  DATADOG_APPLICATION_ID: (meta.VITE_DATADOG_APPLICATION_ID as string) || '',
  DATADOG_CLIENT_TOKEN: (meta.VITE_DATADOG_CLIENT_TOKEN as string) || '',
  DATADOG_SERVICE: (meta.VITE_DATADOG_SERVICE as string) || '',
  DATADOG_SITE: (meta.VITE_DATADOG_SITE as string) || '',
  INTERCOM_APP_ID: (meta.VITE_INTERCOM_APP_ID as string) || '',
  INTERCOM_API_BASE: (meta.VITE_INTERCOM_API_BASE as string) || '',
  APP_VERSION, // https://stackoverflow.com/questions/67194082/how-can-i-display-the-current-app-version-from-package-json-to-the-user-using-vi
  MODE: meta.MODE,

  METABASE_ENABLED: getBool(meta.VITE_METABASE_ENABLED),
  METABASE_INSTANCE_URL: (meta.VITE_METABASE_INSTANCE_URL as string) || '',
  METABASE_INSIGHTS_ENTITY_ID: (meta.VITE_METABASE_INSIGHTS_ENTITY_ID as string) || '',
  METABASE_PS_ENTITY_ID: (meta.VITE_METABASE_PS_ENTITY_ID as string) || '',
  METABASE_USER_GROUP_LG_ENTITY_ID: (meta.VITE_METABASE_USER_GROUP_LG_ENTITY_ID as string) || '',
  METABASE_USER_GROUP_SMALL_ENTITY_ID:
    (meta.VITE_METABASE_USER_GROUP_SMALL_ENTITY_ID as string) || '',
});

export const isProd = () => Environment.MODE === 'production';

export default Environment;
